import * as React from "react"
import styled from "styled-components"
import { ExternalLinksWidgetCard } from "../../../types"
import Button from "../../Button/Button"
import { useTranslation } from "react-i18next"
import IconButton from "../../Button/IconButton"
import ModalFooterComponent from "../../Modals/Parts/ModalFooter"
import TooltipError from "../../Tooltips/ErrorTooltip"
import { WidgetCardsController } from "../../../controllers"
import { closeCustomComponentModal } from "../../../store/modals/actions"
import { connect } from "react-redux"

const Container = styled.div``

const ModalFooter = styled(ModalFooterComponent)`
  margin-left: -20px;
  margin-right: -20px;
  margin-bottom: -20px;
`

interface IDispatchToProps {
  closeCustomComponentModal: typeof closeCustomComponentModal
}

type IProps = {
  widgetId: string
  card: ExternalLinksWidgetCard
  onSubmit: (card: ExternalLinksWidgetCard) => void
} & IDispatchToProps

interface IState {
  card: ExternalLinksWidgetCard
  errors: any[]
}

const ExternalLink = (props: IProps) => {
  const { t } = useTranslation()
  const { widgetId } = props
  const [state, setState] = React.useState<IState>({
    card: props.card,
    errors: []
  })
  const { errors, card } = state

  const onAddLinkClick = () => {
    setState({
      ...state,
      card: {
        ...card,
        external_links: [
          ...card.external_links,
          { label: '', url: '' }
        ]
      }
    })
  }

  const onLabelChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
    const newLinks = [...card.external_links]

    newLinks[index].label = e.target.value

    setState({
      ...state,
      card: {
        ...card,
        external_links: newLinks
      }
    })
  }

  const onLinkChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
    const newLinks = [...card.external_links]

    newLinks[index].url = e.target.value

    setState({
      ...state,
      card: {
        ...card,
        external_links: newLinks
      }
    })
  }

  const onLinkDelete = (index: number) => {
    const newLinks = [...card.external_links]
    newLinks.splice(index, 1)
    setState({
      ...state,
      card: {
        ...card,
        external_links: newLinks
      }
    })
  }

  const onErrorsDismiss = () => {
    setState({ ...state, errors: [] })
  }

  const onSubmit = async (e) => {
    e.preventDefault()

    try {
      let response = null

      if (card.id) {
        response = await WidgetCardsController.update(widgetId, card)
      } else {
        response = await WidgetCardsController.create(widgetId, card)
      }

      if (!response.errors) {
        props.onSubmit(response)
        props.closeCustomComponentModal()
      } else {
        setState({ ...state, errors: response.errors })
      }
    } catch (ex) {
      console.error(ex)
    }
  }

  return (
    <Container>
      <form onSubmit={onSubmit}>
        {card?.external_links?.map((link, index) => (
          <div className="grid">
            <div className="grid-cell with-5col">
              <div className="form-item">
                <label>{t('ExternalLink::Display text')}</label>
                <input
                  type='text'
                  value={link.label}
                  onChange={(e) => onLabelChange(e, index)}
                  placeholder={t('ExternalLink::e.g Ask the community')}
                  required
                />
              </div>
            </div>
            <div className="grid-cell with-5col">
              <div className="form-item">
                <label>{t('ExternalLink::Link')}</label>
                <input
                  type='url'
                  value={link.url}
                  onChange={(e) => onLinkChange(e, index)}
                  placeholder={t('ExternalLink::e.g https://www.askthecommunity.com')}
                  required
                />
              </div>
            </div>
            <div className="grid-cell with-2col">
              <div className="form-item" style={{ marginTop: 30 }}>
                <IconButton
                  onClick={() => onLinkDelete(index)}
                  icon='trash-alt-solid'
                />
              </div>
            </div>
          </div>
        ))}

        <div className="form-item">
          <Button
            text={t('ExternalLink::Add link')}
            type='default'
            onClick={onAddLinkClick}
          />
        </div>
        <ModalFooter>
          <div className='modal-footer'>
            <div />
            <div className='modal-footer-actions'>
              <div key='main-action' className='popover-wrapper'>
                <TooltipError
                  errors={errors}
                  onDismiss={onErrorsDismiss}
                />
                <Button
                  text={t('ExternalLink::Save')}
                  type='success'
                  onClick={onSubmit}
                />
              </div>
            </div>
          </div>
        </ModalFooter>

        <input type='submit' style={{ display: 'none' }} />
      </form>
    </Container>
  )
}

const mapDispatchToProps: IDispatchToProps = {
  closeCustomComponentModal
}

export default connect(null, mapDispatchToProps)(ExternalLink)